import BaseService from '@/services/BaseService'

class CustomerService {

    constructor() {
        this._httpService = new BaseService();
    }

    getCustomers() {
        let settings = {
            baseURL: `${this._httpService.baseUrl}/customer-management/customers`,
            method: 'GET'
        }
        console.info('customers')
        return this._httpService.service(settings)
    }

    getCustomerOptimization() {
        let settings = {
            baseURL: `${this._httpService.baseUrl}/customer-management/customers-optimization`,
            method: 'GET'
        }
        console.info('getCustomerOptimization')
        return this._httpService.service(settings)
    }

}

export default CustomerService